import React from 'react';
import './HelpPage.css';

const HelpPage = () => {
  return (
    <div className="help-page-container">
      <div className="help-content">
        <div className="help-header">
          <h1>About Liminal Coach</h1>
        </div>

        <div className="purpose-section">
          <h3>About Liminal Coach</h3>
          <p>
            Liminal Coach is an AI-powered coaching assistant that helps you run more effective meetings. 
            It provides real-time transcription, analysis, and coaching guidance during your meetings.
          </p>
          
          <h4>Steps to Launch a Meeting:</h4>
          <ol className="steps-list">
            <li><strong>Select your coaching type:</strong> Choose between Liminal or On-Demand meetings</li>
            <li><strong>Pick your meeting and click Start:</strong> Select from available meetings and begin</li>
            <li><strong>Start Recording:</strong>
              <ul>
                <li>Click on the Chrome extension - Liminal Coach extension</li>
                <li>Click on "Start Recording"</li>
                <li>Select the tab with your meeting</li>
                <li>Return to the meeting coach tab</li>
              </ul>
            </li>
            <li><strong>Run Meeting:</strong> Begin your meeting with AI coaching assistance</li>
            <li><strong>Generate Conclusions:</strong> When you get to the end of the meeting, click on generate to help you close it out right</li>
          </ol>
        </div>

        <div className="download-section">
          <h3>Download Liminal Chrome Extension</h3>
          <p>
            To use Liminal Coach effectively, you'll need to install the Chrome extension. 
            This extension enables real-time recording and transcription during your meetings.
          </p>
          <a 
            href="/liminal-extension.zip" 
            download="liminal-extension.zip"
            className="download-button"
          >
            📥 Download Liminal Chrome Extension
          </a>
          <p className="download-instructions">
            After downloading, unzip the file and follow Chrome's extension installation instructions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpPage; 